const es = {
  meta: {
    home: {
      title: "Centauros — Cobrar sin perseguir clientes",
      description:
        "Define políticas de cobro, automatiza recordatorios, genera facturas y cobra sin perseguir a nadie. Todo desde el móvil.",
    },
    privacy: { title: "Política de Privacidad — Centauros", description: "Cómo Centauros protege y trata tus datos." },
    terms: { title: "Términos del Servicio — Centauros", description: "Condiciones de uso de Centauros." },
    support: { title: "Soporte — Centauros", description: "Ayuda y respuestas sobre Centauros." },
    contact: { title: "Contacto — Centauros", description: "Habla con el equipo de Centauros." },
  },
  nav: {
    features: "Características",
    how: "Cómo funciona",
    faq: "Preguntas",
    contact: "Contacto",
    download: "Descargar",
    dashboard: "Panel",
  },
  hero: {"line1": "Cobrar no debería", "line2": "ser otro trabajo.", "subtitle": "Define las reglas desde el principio, automatiza el seguimiento y evita perseguir a tus clientes para cobrar.", "functional": "Centauros te permite definir políticas de cobro, automatizar recordatorios, generar facturas y mantener cada pago bajo control.", "ctaPrimary": "Descargar Centauros", "ctaSecondary": "Ver cómo funciona", "note": "Sin comisiones ocultas · Pagos seguros con Stripe", "availability": "Disponible para iPhone y Android"},
  marquee: [
    "Diseñado para profesionales ecuestres",
    "Seguro",
    "Rápido",
    "Confiable",
    "Cobra sin perseguir",
  ],
  problem: {"label": "El problema", "title": "Cobrar es el problema. Trabajar bien no basta si cobrar se convierte en otro trabajo.", "intro": "Cobras tarde, persigues a tus clientes y adelantas tiempo, materiales y dinero. Estos son los costes reales.", "chapters": [{"n": "01", "title": "Cobros que llegan tarde", "text": "El profesional termina financiando al cliente con su tiempo y su dinero."}, {"n": "02", "title": "Perseguir clientes", "text": "WhatsApps, llamadas y correos incómodos que deberían poder evitarse."}, {"n": "03", "title": "Reglas poco claras", "text": "Cuando las condiciones no se fijan al principio, reclamar después genera conflicto."}, {"n": "04", "title": "Impagos y falta de previsión", "text": "No saber qué vas a cobrar, cuándo, ni qué está vencido."}, {"n": "05", "title": "Coste de oportunidad", "text": "Cada hora reclamando pagos es una hora que no dedicas a trabajar o captar clientes."}]},
  solution: {
    label: "La solución",
    title: "Centauros automatiza el cobro, de principio a fin.",
    subtitle: "Configúralo una vez. Deja que trabaje por ti.",
    items: [
      "Políticas de cobro",
      "Recordatorios",
      "Facturas",
      "Pagos",
      "Seguimiento",
      "Conciliación",
    ],
    footer: "Todo desde el móvil.",
  },
  how: {
    label: "Cómo funciona",
    title: "Cuatro pasos. Cero fricción.",
    steps: [
      { title: "Crear cliente", text: "Añade a tu cliente en segundos con sus datos." },
      { title: "Elegir política", text: "Define cuándo y cómo se cobra automáticamente." },
      { title: "Enviar", text: "Centauros emite y envía la factura por ti." },
      { title: "Cobrar", text: "El pago llega solo. Sin recordatorios manuales." },
    ],
  },
  screens: {
    label: "Pantallas",
    title: "Diseñado con obsesión por el detalle.",
    subtitle: "Cada pantalla, pensada para que cobrar sea invisible.",
    items: [
      { title: "Panel de cobros", text: "Todo lo que se debe, en un vistazo." },
      { title: "Políticas", text: "Reglas de cobro claras y reutilizables." },
      { title: "Facturas", text: "Genera y envía en un toque." },
      { title: "Pagos", text: "Seguros, con Stripe, en tiempo real." },
    ],
  },
  features: {
    label: "Características",
    title: "Todo lo que necesitas para cobrar mejor.",
    cards: [
      { title: "Control total", text: "Una visión clara de cada cobro y cada cliente." },
      { title: "Automatización", text: "Las tareas repetitivas se ejecutan solas." },
      { title: "Facturación", text: "Facturas profesionales generadas al instante." },
      { title: "Cobros", text: "Pagos automáticos según tus políticas." },
      { title: "Equipo", text: "Invita a tu equipo y trabajad juntos." },
      { title: "Seguridad", text: "Infraestructura segura y datos protegidos." },
      { title: "Pagos", text: "Cobra con tarjeta de forma segura vía Stripe." },
      { title: "Historial", text: "Cada movimiento registrado y conciliado." },
    ],
  },
  audience: {
    label: "Para quién es",
    title: "Hecho para quienes viven de su trabajo.",
    subtitle: "Si tu tiempo vale, Centauros es para ti.",
    roles: ["Veterinarios", "Herradores", "Entrenadores", "Transportistas", "Profesionales ecuestres"],
    note: "Y cualquier profesional que quiera cobrar mejor.",
  },
  security: {
    label: "Seguridad",
    title: "Tu dinero y tus datos, protegidos.",
    subtitle: "Construido sobre infraestructura de confianza.",
    points: [
      { title: "Pagos con Stripe", text: "Procesamos pagos con el estándar líder del sector." },
      { title: "Infraestructura segura", text: "Cifrado en tránsito y en reposo." },
      { title: "Privacidad", text: "Tus datos son tuyos. Nunca los vendemos." },
      { title: "Protección de datos", text: "Cumplimiento y buenas prácticas por diseño." },
      { title: "Sin almacenar tarjetas", text: "Nunca guardamos los datos de las tarjetas." },
    ],
  },
  faq: {
    label: "Preguntas frecuentes",
    title: "Todo lo que quieres saber.",
    items: [
      { q: "¿Qué es Centauros?", a: "Una app para definir políticas de cobro, automatizar recordatorios, generar facturas y cobrar sin perseguir a nadie." },
      { q: "¿Necesito conocimientos técnicos?", a: "No. Se configura en minutos y funciona desde el móvil." },
      { q: "¿Cómo se procesan los pagos?", a: "Los pagos se procesan de forma segura a través de Stripe." },
      { q: "¿Guardáis los datos de mi tarjeta?", a: "Nunca. No almacenamos datos de tarjetas en ningún momento." },
      { q: "¿Puedo automatizar los recordatorios?", a: "Sí. Defines la política una vez y Centauros se encarga del resto." },
      { q: "¿Puedo generar facturas?", a: "Sí, facturas profesionales al instante y listas para enviar." },
      { q: "¿Funciona para mi profesión?", a: "Está pensado para profesionales ecuestres y cualquiera que quiera cobrar mejor." },
      { q: "¿Puedo trabajar con mi equipo?", a: "Sí, puedes invitar a tu equipo y colaborar." },
      { q: "¿Está disponible en varios idiomas?", a: "Sí, Centauros está disponible en 12 idiomas." },
      { q: "¿Dónde puedo descargarla?", a: "Muy pronto en la App Store para iPhone." },
    ],
  },
  finalCta: {
    title: "Empieza hoy.",
    subtitle: "Descarga Centauros y deja de perseguir clientes.",
    badge: "Descargar en la App Store",
  },
  footer: {
    statement1: "Cobrar deja de ser",
    statement2: "otro trabajo.",
    download: "Descargar Centauros",
    secure: "Pagos seguros",
    tagline: "Cobrar sin perseguir clientes.",
    colProduct: "Producto",
    colCompany: "Empresa",
    colLegal: "Legal",
    links: {
      home: "Inicio",
      features: "Características",
      faq: "Preguntas",
      contact: "Contacto",
      privacy: "Privacidad",
      terms: "Términos",
      support: "Soporte",
      download: "Descargar",
    },
    contactLabel: "Contacto",
    rights: "© Centauros. Todos los derechos reservados.",
  },
  contact: {
    title: "Hablemos.",
    subtitle: "¿Tienes una pregunta o quieres saber más? Escríbenos.",
    fields: { name: "Nombre", email: "Email", subject: "Asunto", message: "Mensaje" },
    placeholders: { name: "Tu nombre", email: "tu@email.com", subject: "¿En qué podemos ayudarte?", message: "Cuéntanos..." },
    submit: "Enviar mensaje",
    sending: "Enviando...",
    success: "Mensaje enviado. Te responderemos pronto.",
    error: "No se pudo enviar. Inténtalo de nuevo.",
    directLabel: "O escríbenos directamente a",
  },
  legal: {
    privacy: {
      title: "Política de Privacidad",
      updated: "Última actualización: junio de 2026",
      body: [
        { h: "Introducción", p: "En Centauros nos tomamos tu privacidad muy en serio. Esta política explica qué datos tratamos y con qué finalidad." },
        { h: "Datos que tratamos", p: "Tratamos los datos necesarios para prestar el servicio: cuenta, clientes que gestionas y cobros que realizas." },
        { h: "Pagos", p: "Los pagos se procesan a través de Stripe. Nunca almacenamos los datos de tu tarjeta ni los de tus clientes." },
        { h: "Uso de los datos", p: "Usamos tus datos únicamente para prestar y mejorar el servicio. Nunca vendemos tu información a terceros." },
        { h: "Tus derechos", p: "Puedes acceder, rectificar o eliminar tus datos en cualquier momento escribiendo a support@centauros.app." },
      ],
    },
    terms: {
      title: "Términos del Servicio",
      updated: "Última actualización: junio de 2026",
      body: [
        { h: "Aceptación", p: "Al usar Centauros aceptas estos términos. Si no estás de acuerdo, no utilices el servicio." },
        { h: "Uso del servicio", p: "Te comprometes a usar Centauros de forma lícita y a mantener la seguridad de tu cuenta." },
        { h: "Pagos y cobros", p: "Los cobros se procesan mediante Stripe conforme a sus condiciones. Eres responsable de la relación con tus clientes." },
        { h: "Responsabilidad", p: "Centauros se ofrece «tal cual». Trabajamos para garantizar su disponibilidad y seguridad continuas." },
        { h: "Cambios", p: "Podemos actualizar estos términos. Notificaremos los cambios relevantes a través de la app." },
      ],
    },
    support: {
      title: "Soporte",
      updated: "Estamos aquí para ayudarte.",
      intro: "Encuentra respuestas rápidas o contáctanos directamente. Respondemos lo antes posible.",
      faqs: [
        { q: "¿Cómo empiezo?", a: "Descarga la app, crea tu cuenta y añade tu primer cliente en minutos." },
        { q: "¿Cómo automatizo los cobros?", a: "Crea una política de cobro y asígnala a tus clientes. El resto es automático." },
        { q: "¿Tengo un problema con un pago?", a: "Escríbenos a support@centauros.app y lo revisamos contigo." },
        { q: "¿Puedo exportar mi información?", a: "Sí, puedes solicitar la exportación de tus datos en cualquier momento." },
      ],
      contactLine: "¿Necesitas más ayuda? Escríbenos a",
    },
  },
  common: { languageLabel: "Idioma", backHome: "Volver al inicio", loading: "Cargando..." },
  philosophy: {"label": "La filosofía", "title": "Las reglas de cobro se establecen", "titleGreen": "antes de empezar.", "text": "A veces es mejor no aceptar un cliente que aceptar uno que te obliga a adelantar tiempo, dinero y recursos sin saber cuándo cobrarás. Centauros permite acordar desde el principio cómo, cuándo y cuánto se va a pagar.", "points": ["Definir políticas de cobro", "Prevenir problemas", "Asegurar compromisos", "Automatizar el seguimiento", "Mantener el control financiero", "Reducir la fricción con el cliente"]},
  showcase: {"label": 'El producto', "slides": [{"id": "control", "title": "Controla todo lo que", "green": "tienes que cobrar", "text": "Visión clara de cada cobro y de tu negocio, siempre a mano."}, {"id": "policies", "title": "Tú decides", "green": "cómo y cuándo deben pagarte", "text": "Pago anticipado, reserva + saldo, al finalizar o recurrente. Elige la política que encaja."}, {"id": "clients", "title": "Cada cliente,", "green": "toda la información que necesitas", "text": "Datos, pagos, suscripciones e historial en un solo lugar."}, {"id": "payments", "title": "Cada cobro,", "green": "bajo control", "text": "Estado en tiempo real, recordatorios automáticos y factura al instante."}, {"id": "impagos", "title": "Detecta los impagos", "green": "antes de que crezcan", "text": "Centauros hace el seguimiento, reclama y te ayuda a recuperar lo vencido."}, {"id": "facturacion", "title": "Cobros y facturas", "green": "siempre conciliados", "text": "Emite, revisa y concilia todas tus facturas desde un solo lugar."}, {"id": "equipo", "title": "Tu equipo,", "green": "todo bajo control", "text": "Invita a tu equipo, asigna roles y gestionad los cobros juntos."}]},
  badges: {"appStoreTop": "Descárgalo en", "appStoreLabel": "App Store", "playTop": "Disponible en", "playLabel": "Google Play"},
  partners: {"label": "Con la tecnología de los mejores partners de pago"},
  dashboard: {
    loginTitle: "Panel de Centauros",
    loginSubtitle: "Acceso privado de administración.",
    email: "Email",
    password: "Contraseña",
    signIn: "Entrar",
    signingIn: "Entrando...",
    invalid: "Credenciales incorrectas.",
    logout: "Cerrar sesión",
    nav: { overview: "Resumen", users: "Usuarios", workspaces: "Workspaces", activity: "Actividad", incidents: "Incidencias" },
    metrics: { users: "Usuarios totales", active: "Usuarios activos", workspaces: "Workspaces", incidents: "Incidencias abiertas", collected: "Total cobrado" },
    tableUsers: { name: "Nombre", email: "Email", profession: "Profesión", status: "Estado" },
    tableWorkspaces: { name: "Workspace", members: "Miembros", plan: "Plan", collected: "Cobrado" },
    tableIncidents: { title: "Título", workspace: "Workspace", severity: "Severidad", status: "Estado" },
    recentActivity: "Actividad reciente",
  },
  policies: {
    label: "Políticas de cobro",
    title: "Tú decides cómo y cuándo te pagan.",
    subtitle: "Configura la política que encaja con cada cliente y Centauros la aplica automáticamente.",
    methods: [
      { name: "Pago anticipado", desc: "Cobra el importe completo antes de empezar. Cero riesgo." },
      { name: "Reserva + saldo", desc: "Una reserva ahora y el resto al finalizar el trabajo." },
      { name: "Pago al finalizar", desc: "El cliente paga automáticamente cuando terminas." },
      { name: "Pago recurrente", desc: "Suscripciones y cuotas que se cobran solas cada periodo." },
      { name: "Extras posteriores", desc: "Añade cargos adicionales después del servicio, sin fricción." },
      { name: "Pago por hitos", desc: "Divide el cobro en fases y cobra a medida que avanzas." },
    ],
    ui: { upfront: "Pago anticipado", paid: "Cobrado", pending: "Pendiente", total: "Total", deposit: "Reserva", balance: "Saldo", completed: "Completado", dueOnFinish: "Al finalizar", monthly: "Mensual", nextCharge: "Próximo cobro", extra: "Extra", milestone: "Hito" },
  },
  redesign: { comingSoon: "Próximamente" },
  appui: { hello: "Hola", toCollect: "Por cobrar", collected: "Cobrado", overdue: "Vencido", activity: "Actividad", pending: "Pendiente", paid: "Cobrado", advance: "Pago anticipado", extra: "Extra", payNow: "Pagar ahora" },
  faqx: [
    { q: "¿Qué es Centauros?", a: "Centauros es una plataforma para definir políticas de cobro, automatizar pagos, generar facturas y reducir impagos sin perseguir a tus clientes. Configuras tus reglas una vez y la app cobra, recuerda y concilia por ti." },
    { q: "¿Para quién está pensado?", a: "Para cualquier profesional o empresa que cobre por sus servicios: entrenadores, veterinarios, abogados, consultores, agencias, clínicas, gimnasios o empresas de servicios. Si emites cobros recurrentes o por proyecto, Centauros se adapta a tu forma de trabajar." },
    { q: "¿Necesitan mis clientes instalar la aplicación?", a: "No. Tus clientes reciben enlaces de pago y comunicaciones directamente; no necesitan descargar nada. Solo tú, como profesional, usas la app de Centauros." },
    { q: "¿Qué métodos de pago puedo aceptar?", a: "Gracias a Stripe puedes aceptar tarjetas de crédito y débito, Apple Pay, Google Pay y el resto de métodos disponibles en tu país. Los métodos concretos dependen de la cobertura de Stripe en cada región." },
    { q: "¿Puedo decidir cuándo y cómo me pagan?", a: "Sí. Configura pago anticipado, reserva + saldo, pago al finalizar, pagos recurrentes, extras posteriores o pago por hitos. Defines la política que mejor encaja con cada cliente o servicio." },
    { q: "¿Centauros genera las facturas automáticamente?", a: "Sí. Puede crear borradores, emitir facturas automáticamente tras el pago o seguir la política de facturación que configures. Todas quedan registradas y listas para enviar." },
    { q: "¿Qué ocurre si un cliente no paga?", a: "Centauros hace el seguimiento por ti: envía recordatorios automáticos, controla los vencimientos y marca los impagos, ayudándote a recuperar lo pendiente sin conversaciones incómodas." },
    { q: "¿Es seguro utilizar Centauros?", a: "Sí. Los pagos se procesan íntegramente a través de Stripe, los datos viajan cifrados y nunca almacenamos los datos de las tarjetas. La plataforma sigue buenas prácticas de seguridad en todo el proceso." },
    { q: "¿En qué países está disponible?", a: "Centauros está preparado para operar internacionalmente. Los métodos de pago disponibles dependen de los países soportados por Stripe, que cubre la mayoría de mercados en Europa, América y otras regiones." },
    { q: "¿Cómo puedo empezar?", a: "Descarga la aplicación, crea tu cuenta y configura tu primera política de cobro en pocos minutos. Desde ese momento puedes empezar a cobrar y automatizar tus pagos." },
  ],
  legalx: {
    eyebrow: "Legal", contents: "Contenido", questions: "¿Dudas sobre esta página? Escríbenos.",
    navPrivacy: "Privacidad", navTerms: "Términos", navCookies: "Cookies", navSupport: "Soporte",
    cookiesMetaTitle: "Política de Cookies — Centauros", cookiesMetaDesc: "Cómo Centauros utiliza cookies y tecnologías similares.",
    privacy: {
      title: "Política de Privacidad", updated: "Última actualización: junio de 2026", intro: "Cómo Centauros recoge, utiliza y protege tus datos personales.",
      body: [
        { h: "Introducción", p: "En Centauros la privacidad es un principio de diseño, no un añadido. Esta política explica qué datos tratamos, con qué finalidad, durante cuánto tiempo y qué derechos tienes sobre ellos." },
        { h: "Responsable del tratamiento", p: "El responsable del tratamiento es Centauros. Para cualquier cuestión relativa a esta política o a tus datos, puedes escribirnos a support@centauros.app." },
        { h: "Datos que tratamos", p: "Tratamos los datos de tu cuenta (nombre, email y credenciales), los datos de los clientes que gestionas, la información de tus cobros y facturas, y datos técnicos de uso necesarios para el funcionamiento del servicio." },
        { h: "Finalidad del tratamiento", p: "Usamos tus datos para prestar el servicio, procesar cobros, generar facturas, enviar recordatorios, darte soporte y mejorar la plataforma. No los utilizamos para fines ajenos al servicio." },
        { h: "Pagos y Stripe", p: "Los pagos se procesan a través de Stripe. Nunca almacenamos los datos completos de las tarjetas: los gestiona directamente Stripe conforme al estándar PCI-DSS." },
        { h: "Conservación de los datos", p: "Conservamos tus datos mientras tu cuenta esté activa y durante el tiempo necesario para cumplir obligaciones legales, contables y fiscales. Después los eliminamos o anonimizamos." },
        { h: "Compartir información", p: "No vendemos tu información. Solo compartimos datos con los proveedores necesarios para operar el servicio (como Stripe o la infraestructura de alojamiento), siempre bajo acuerdos de protección de datos." },
        { h: "Tus derechos", p: "Puedes acceder, rectificar, eliminar, limitar u oponerte al tratamiento de tus datos, así como solicitar su portabilidad, escribiendo a support@centauros.app. Atenderemos tu solicitud lo antes posible." },
        { h: "Seguridad y cambios", p: "Aplicamos cifrado en tránsito y en reposo y controles de acceso para proteger tu información. Podemos actualizar esta política; indicaremos siempre la fecha de última actualización." },
      ],
    },
    terms: {
      title: "Términos del Servicio", updated: "Última actualización: junio de 2026", intro: "Las condiciones que regulan el uso de Centauros.",
      body: [
        { h: "Aceptación de los términos", p: "Al crear una cuenta o utilizar Centauros aceptas estos Términos del Servicio. Si no estás de acuerdo con ellos, no debes utilizar la plataforma." },
        { h: "Descripción del servicio", p: "Centauros es una herramienta para definir políticas de cobro, automatizar pagos y recordatorios, generar facturas y gestionar impagos. Actuamos como plataforma tecnológica; no somos parte de la relación comercial entre tú y tus clientes." },
        { h: "Tu cuenta", p: "Eres responsable de la veracidad de los datos de tu cuenta y de mantener la confidencialidad de tus credenciales. Toda actividad realizada desde tu cuenta se considera realizada por ti." },
        { h: "Uso aceptable", p: "Te comprometes a utilizar Centauros de forma lícita, sin infringir derechos de terceros ni emplear la plataforma para actividades fraudulentas o no autorizadas." },
        { h: "Pagos y Stripe", p: "Los cobros se procesan a través de Stripe y quedan sujetos a sus condiciones. Eres responsable de la relación con tus clientes, de la legalidad de tus cobros y del cumplimiento de tus obligaciones fiscales." },
        { h: "Facturación", p: "Centauros facilita la generación de facturas, pero la responsabilidad sobre su contenido, exactitud y cumplimiento legal corresponde al profesional que las emite." },
        { h: "Propiedad intelectual", p: "La plataforma, su marca, diseño y software son propiedad de Centauros. Estos términos no te otorgan ningún derecho sobre ellos más allá del uso del servicio." },
        { h: "Disponibilidad y responsabilidad", p: "Centauros se ofrece «tal cual». Trabajamos para garantizar su disponibilidad y seguridad, pero no garantizamos un funcionamiento ininterrumpido ni asumimos pérdidas derivadas de un uso indebido." },
        { h: "Cancelación y cambios", p: "Puedes cerrar tu cuenta cuando quieras; podemos suspender cuentas que incumplan estos términos. Podemos actualizarlos y notificaremos los cambios relevantes indicando la fecha." },
      ],
    },
    cookies: {
      title: "Política de Cookies", updated: "Última actualización: junio de 2026", intro: "Cómo utilizamos cookies y tecnologías similares en centauros.app.",
      body: [
        { h: "Qué son las cookies", p: "Las cookies son pequeños archivos que se almacenan en tu dispositivo cuando visitas un sitio web. Sirven para recordar preferencias y entender cómo se utiliza el sitio." },
        { h: "Cómo usamos las cookies", p: "Utilizamos cookies para el funcionamiento básico del sitio, recordar tu idioma y medir de forma agregada el uso para mejorar la experiencia." },
        { h: "Cookies esenciales", p: "Son imprescindibles para que la web funcione correctamente, como recordar tu idioma o mantener la sesión. No pueden desactivarse." },
        { h: "Cookies de analítica", p: "Nos ayudan a entender el uso del sitio de forma anónima y agregada. Cuando aplica, solo se activan con tu consentimiento." },
        { h: "Gestión de cookies", p: "Puedes configurar o eliminar las cookies desde los ajustes de tu navegador. Desactivar algunas puede afectar al funcionamiento del sitio." },
        { h: "Cambios en esta política", p: "Podemos actualizar esta política de cookies. Publicaremos cualquier cambio en esta página, indicando la fecha de última actualización." },
      ],
    },
  },
  product2: {
    p1title: "Deja de perseguir. Empieza a cobrar.",
    p1sub: "El seguimiento manual te hace perder dinero. Con Centauros defines la política y cobras solo, sin conversaciones incómodas.",
    p1cta: "Descargar Centauros",
    p1link: "Descubre cómo funciona",
    p1cardTitle: "De cada 1.000 € facturados",
    p1cardCol: "Acabas cobrando",
    p1rows: [
      { name: "Centauros", amount: "1.000 €" },
      { name: "Recordatorios manuales", amount: "910 €", delta: "−90 €" },
      { name: "Sin seguimiento", amount: "820 €", delta: "−180 €" },
    ],
    p2title: "Cobra por tu trabajo, sin fricción.",
    p2sub: "Enlaces de pago, políticas y facturas automáticas. Defines las reglas una vez y Centauros hace el resto.",
    p2cta: "Descubre cómo funciona",
    p2policy: "Política · Reserva + saldo",
    p2sendLabel: "El cliente paga",
    p2client: "Cliente",
    p2info: "¿Cobro recurrente? Configúralo una vez y se cobra solo cada periodo.",
    p2recipLabel: "Tú recibes",
    p2you: "Tú",
    p2arrives: "Se cobra",
    p2arrivesVal: "Hoy · automático",
    p2fees: "Comisiones",
    p2feesVal: "Incluidas",
    p3title: "Haz mucho más con Centauros.",
    p3sub: "No es solo cobrar: gestiona clientes, facturas, impagos y tu equipo desde un único lugar.",
    p3cta: "Crear cuenta",
    p3cardLabel: "Por cobrar",
    p3feat: "Recibe pagos al instante",
    p3featDesc: "Enlaces de pago y cobros automáticos con la infraestructura de Stripe.",
    p3check: "Múltiples métodos de pago",
    p3cta2: "Explora los cobros",
    p4title: "Recupera los impagos que dabas por perdidos.",
    p4sub: "Centauros reclama automáticamente los pagos atrasados con recordatorios y reintentos, hasta que cobras.",
    p4cta: "Descubre cómo funciona",
    p4cardLabel: "Impagos recuperados",
    p4foot: "Los profesionales recuperan de media un 38 % más de impagos en los primeros 6 meses.",
  },
  pricing: {
    label: "Precios",
    title: "Precios claros. Sin sorpresas.",
    subtitle: "Solo pagas cuando cobras. Stripe cobra su comisión por procesar el pago y Centauros añade un 1 % por la automatización, la gestión de cobros y toda la plataforma.",
    stripeTitle: "Comisión de Stripe",
    stripeDesc: "Stripe procesa el pago de forma segura. Su comisión varía según el país y el método de pago; el ejemplo mostrado es para tarjetas europeas.",
    centaurosTitle: "Comisión de Centauros",
    centaurosDesc: "Un 1 % sobre el importe por la automatización, el seguimiento de cobros y toda la plataforma. Sin cuotas mensuales ocultas.",
    calcTitle: "Calcula lo que recibes",
    invoiceAmount: "Importe de la factura",
    stripeFee: "Comisión Stripe",
    centaurosFee: "Comisión Centauros (1%)",
    received: "El profesional recibe",
    note: "La comisión real de Stripe puede variar según el país y el método de pago. Los importes mostrados son un ejemplo orientativo.",
  },
  cookie: {
    title: "Tu privacidad, tu decisión",
    intro: "Usamos cookies para que Centauros funcione correctamente, recordar tus preferencias y entender de forma anónima cómo se usa la web. Tú eliges qué activar, y puedes cambiar tu decisión cuando quieras.",
    required: "Siempre activas",
    acceptAll: "Aceptar todas",
    rejectAll: "Rechazar todas",
    save: "Guardar preferencias",
    reopen: "Preferencias de cookies",
    footnote: "Puedes modificar tu consentimiento en cualquier momento desde el pie de página.",
    policyLink: "Política de cookies",
    categories: {
      necessary: { name: "Necesarias", desc: "Imprescindibles para el funcionamiento y la seguridad del sitio. No se pueden desactivar." },
      preferences: { name: "Preferencias", desc: "Recuerdan tus ajustes, como el idioma, para ofrecerte una experiencia más cómoda." },
      analytics: { name: "Analítica", desc: "Nos ayudan a entender de forma anónima cómo se usa la web para mejorarla." },
      marketing: { name: "Marketing", desc: "Permiten mostrarte contenido y anuncios más relevantes dentro y fuera del sitio." },
    },
  },
};
export default es;
